module.exports = __webpack_public_path__ + "static/media/marketing_creatives.b9f0c592.svg";